<template>
  <div>
    <div class="container flex align-end height-100-vh justify-center">
      <form class="login width-100 mb-15" @submit.prevent="signIn()" autocomplete="on">
        <img alt="Vue logo" src="../assets/logo_default.svg" class="login-logo">
        <input type="email" v-model="email" class="mb-15" placeholder="E-postadress" autocomplete="email" required>
        <input type="password" v-model="password" class="mb-50" placeholder="Lösenord" autocomplete="current-password" required>
        <button type="submit" :disabled="processingSignIn">{{ buttonText }}</button>
      </form>
    </div>
    <message title="Åhnej!" v-bind:body="errors" v-if="errors.length" @close="errors = false"></message>
  </div>
</template>

<script>
import Message from '../components/Message';
export default {
  name: 'Login',
  components: {
    Message
  },
  mounted() {
    document.body.classList.add('login-page')
  },
  data() {
    return {
      email : '',
      password: '',
      errors: '',
      processingSignIn: false
    }
  },
  computed: {
    buttonText() {
      return this.processingSignIn ? 'loggar in...' : 'logga in';
    }
  },
  methods: {
    signIn() {
      let data = {
        username: this.email,
        password: this.password
      };
      this.processingSignIn = !this.processingSignIn;
      this.$root.callFasAdApi("/internalapi/auth/login", "POST", data)
      .then((response) => {
        if (response.status === 200) {
          this.$store.commit('SET_AUTHENTICATED', data.username);
          document.body.classList.remove('login-page');
          this.$router.push('/');
        } else {
          this.$root.handleResponseMessage(response);
        }
        this.processingSignIn = !this.processingSignIn;
      })
      .catch(console.error);
    }
  }
}
</script>
<style>
.login-page #app {
  background: url('../assets/login.svg') -110px 30px no-repeat;
  background-size: calc(.77 * 100vh);
}

.login {
  display: flex;
  flex-direction: column;
  align-content: flex-end;
}

.login-logo {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 110px;
  display: block;
  margin: 0 auto 100px;
}

.login-page input {
  background-color: transparent;
  padding-left: 0;
  border:none;
  outline: none;
  border-radius: 0;
  border-bottom: 1px solid var(--fasad-grey-3);
}
</style>
